import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Banner } from "./components/printing/Banner";
import { Sample } from "./components/printing/Sample";
import { Products } from "./components/printing/Products";
import { Contact } from "./components/Contact";
import { WhyUs } from "./components/WhyUs";
import { Footer } from "./components/Footer";
import { Testimony } from './components/Testimony';
import { HeaderPrinting } from './components/printing/HeaderPrinting';
import { Capacity } from './components/printing/Capacity';

function AppPrinting() {
  return (
    <div className="App">
      <HeaderPrinting />
      <Banner />
      <Sample />
      <Products />
      <Capacity />
      <Testimony />
      <WhyUs />
      <Contact />
      <Footer />
    </div>
  );
}

export default AppPrinting;
